export default value => Intl.NumberFormat('en-US').format(value?.toFixed(2) ?? 0)
